<template>
  <div>
    <main id="#main" class="u-mt30">
      <h2 class="c-level2">
        <span>
          インターンスカウト登録
        </span>
      </h2>
      <div class="c-card-default c-documents">
        <h3 class="c-level3">
          自分が主役のわがまま要望を出そう！
        </h3>
        <ul class="c-formList">
          <li>
            <label class="c-label" for="lineName">Lineで使っている名前</label>
            <input type="text" v-model="$v.internForm.lineName.$model" placeholder="例：めもり たろう" id="lineName" class="c-inputText">
            <ul class="c-validateError" v-show="$v.internForm.lineName.$error">
              <li v-show="!$v.internForm.lineName.required">入力が必須の項目です。</li>
            </ul>
          </li>
          <li>
            <label class="c-label" for="area">エリア</label>
            <div class="c-select">
              <select id="area" v-model="$v.internForm.area.$model">
                <option value="">選択してください</option>
                <option value="渋谷/表参道/原宿">渋谷/表参道/原宿</option>
                <option value="新宿/代々木/高田馬場">新宿/代々木/高田馬場</option>
                <option value="池袋/目白">池袋/目白</option>
                <option value="北千住/錦糸町/小岩">北千住/錦糸町/小岩</option>
                <option value="市川/船橋/津田沼">市川/船橋/津田沼</option>
              </select>
            </div>
            <ul class="c-validateError" v-show="$v.internForm.area.$error">
              <li v-show="!$v.internForm.area.required">入力が必須の項目です。</li>
            </ul>
          </li>
          <li>
            <label class="c-label" for="request">優先希望</label>
            <div class="c-select">
              <select id="request" v-model="$v.internForm.request.$model">
                <option value="">選択してください</option>
                <option value="仕事の幅広さ・技術・経験">仕事の幅広さ・技術・経験</option>
                <option value="一緒に働く方の人柄">一緒に働く方の人柄</option>
                <option value="報酬・時給">報酬・時給</option>
                <option value="その他">その他</option>
              </select>
            </div>
            <ul class="c-validateError" v-show="$v.internForm.request.$error">
              <li v-show="!$v.internForm.request.required">入力が必須の項目です。</li>
            </ul>
          </li>
          <li>
            <label class="c-label" for="schoolName">学校名</label>
            <input type="text" v-model="$v.internForm.schoolName.$model" placeholder="例：●●専門学校" id="schoolName" class="c-inputText">
            <ul class="c-validateError" v-show="$v.internForm.schoolName.$error">
              <li v-show="!$v.internForm.schoolName.required">入力が必須の項目です。</li>
            </ul>
          </li>
          <li>
            <label class="c-label" for="schoolYear">学年</label>
            <div class="c-select">
              <select id="schoolYear" v-model="$v.internForm.schoolYear.$model">
                <option value="">選択してください</option>
                <option value="1年生">1年生</option>
                <option value="2年生">2年生</option>
                <option value="その他">その他</option>
              </select>
            </div>
            <ul class="c-validateError" v-show="$v.internForm.schoolYear.$error">
              <li v-show="!$v.internForm.schoolYear.required">入力が必須の項目です。</li>
            </ul>
          </li>
          <li>
            <label class="c-label" for="sex">性別</label>
            <div class="c-select">
              <select id="sex" v-model="$v.internForm.sex.$model">
                <option value="">選択してください</option>
                <option value="男性">男性</option>
                <option value="女性">女性</option>
                <option value="その他">その他</option>
              </select>
            </div>
            <ul class="c-validateError" v-show="$v.internForm.sex.$error">
              <li v-show="!$v.internForm.sex.required">入力が必須の項目です。</li>
            </ul>
          </li>
        </ul>
        <p class="c-btn--primary u-mt30" @click="submit()"  v-if="
          !$v.internForm.lineName.$invalid
          && !$v.internForm.area.$invalid
          && !$v.internForm.request.$invalid
          && !$v.internForm.schoolName.$invalid
          && !$v.internForm.schoolYear.$invalid
          && !$v.internForm.sex.$invalid
        ">
          送信する
        </p>
        <p class="c-btn--primary c-btn--disabled u-mt30" v-else>
          送信する
        </p>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { Mixin } from '@/mixin'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'app',
  data () {
    return {
      internForm: {
        lineName: '',
        area: '',
        request: '',
        schoolName: '',
        schoolYear: '',
        sex: ''
      }
    }
  },
  components: {
    Footer
  },
  head: {
    title: function () {
      return {
        inner: 'インターンスカウト登録',
        separator: '|',
        complement: 'memorii'
      }
    }
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      vm.$store.commit('SET_LOADING', true)
      await Promise.all(promises).then(function () {
        vm.$store.commit('SET_LOADING', false)
      })
    })
  },
  methods: {
    submit: async function () {
      const promises = []
      const that = this
      const payload = {
        title: 'memorii美容学生インターン',
        content: 'Lineで使っている名前：\n' + this.internForm.lineName + '\n\n' +
        'エリア：\n' + this.internForm.area + '\n\n' +
        '優先希望：\n' + this.internForm.request + '\n\n' +
        '学校名：\n' + this.internForm.schoolName + '\n\n' +
        '学年：\n' + this.internForm.schoolYear + '\n\n' +
        '性別：\n' + this.internForm.sex
      }

      this.$store.commit('SET_LOADING', true)
      promises.push(this.$store.dispatch('SEND_INTERN', payload))
      await Promise.all(promises).then(function () {
        that.$store.commit('SET_LOADING', false)
        that.$router.push({ path: '/intern-finish/' })
      }).catch(function (error) {
        that.$store.commit('SET_LOADING', false)
        alert(error.message)
      })
    }
  },
  mixins: [Mixin, validationMixin],
  validations: {
    internForm: {
      lineName: {
        required
      },
      area: {
        required
      },
      request: {
        required
      },
      schoolName: {
        required
      },
      schoolYear: {
        required
      },
      sex: {
        required
      }
    }
  }
}
</script>
